 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({}[chunkId]||chunkId) + "." + {"1":"cb505266a22c4d6dcbd2","2":"dc1c2e3b33576079ecd0"}[chunkId] + ".bundle.js"
 	}

 	// object to store loaded and loading wasm modules
 	var installedWasmModules = {};

 	function promiseResolve() { return Promise.resolve(); }

 	var wasmImportObjects = {
 		57: function() {
 			return {
 				"./compose_area_bg.js": {
 					"__wbindgen_object_drop_ref": function(p0i32) {
 						return installedModules[2].exports["ub"](p0i32);
 					},
 					"__wbindgen_object_clone_ref": function(p0i32) {
 						return installedModules[2].exports["tb"](p0i32);
 					},
 					"__wbindgen_string_new": function(p0i32,p1i32) {
 						return installedModules[2].exports["vb"](p0i32,p1i32);
 					},
 					"__wbg_new_59cb74e423758ede": function() {
 						return installedModules[2].exports["U"]();
 					},
 					"__wbg_stack_558ba5917b466edd": function(p0i32,p1i32) {
 						return installedModules[2].exports["lb"](p0i32,p1i32);
 					},
 					"__wbg_error_4bb6c2a97407129a": function(p0i32,p1i32) {
 						return installedModules[2].exports["u"](p0i32,p1i32);
 					},
 					"__wbg_instanceof_Window_0e8decd0a6179699": function(p0i32) {
 						return installedModules[2].exports["O"](p0i32);
 					},
 					"__wbg_document_76c349f54c28c8fa": function(p0i32) {
 						return installedModules[2].exports["r"](p0i32);
 					},
 					"__wbg_getSelection_a6200f7c3b066e96": function(p0i32) {
 						return installedModules[2].exports["A"](p0i32);
 					},
 					"__wbg_createRange_7417ae8c2e527350": function(p0i32) {
 						return installedModules[2].exports["n"](p0i32);
 					},
 					"__wbg_getElementById_35de356b82960e7f": function(p0i32,p1i32,p2i32) {
 						return installedModules[2].exports["y"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_alt_c8bbd91d34bbf4a4": function(p0i32,p1i32) {
 						return installedModules[2].exports["d"](p0i32,p1i32);
 					},
 					"__wbg_startContainer_6a277da441b04299": function(p0i32) {
 						return installedModules[2].exports["mb"](p0i32);
 					},
 					"__wbg_startOffset_10a5db36288ab8a9": function(p0i32) {
 						return installedModules[2].exports["nb"](p0i32);
 					},
 					"__wbg_endContainer_75a43a2998c34fe0": function(p0i32) {
 						return installedModules[2].exports["s"](p0i32);
 					},
 					"__wbg_endOffset_63cef9ef59a82402": function(p0i32) {
 						return installedModules[2].exports["t"](p0i32);
 					},
 					"__wbg_collapsed_59ac2df717b32dd2": function(p0i32) {
 						return installedModules[2].exports["k"](p0i32);
 					},
 					"__wbg_commonAncestorContainer_2f3f55bc613489fe": function(p0i32) {
 						return installedModules[2].exports["l"](p0i32);
 					},
 					"__wbg_cloneRange_095edaadd47fd4f4": function(p0i32) {
 						return installedModules[2].exports["i"](p0i32);
 					},
 					"__wbg_collapse_8aed7ef93ec94d6e": function(p0i32,p1i32) {
 						return installedModules[2].exports["j"](p0i32,p1i32);
 					},
 					"__wbg_deleteContents_e70a762de08f3104": function(p0i32) {
 						return installedModules[2].exports["q"](p0i32);
 					},
 					"__wbg_insertNode_9f8bb90475329f67": function(p0i32,p1i32) {
 						return installedModules[2].exports["I"](p0i32,p1i32);
 					},
 					"__wbg_setEnd_da02a3b4f5aa3925": function(p0i32,p1i32,p2i32) {
 						return installedModules[2].exports["hb"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_setEndAfter_e0b437572d9413e7": function(p0i32,p1i32) {
 						return installedModules[2].exports["fb"](p0i32,p1i32);
 					},
 					"__wbg_setEndBefore_cb49508018c70aa4": function(p0i32,p1i32) {
 						return installedModules[2].exports["gb"](p0i32,p1i32);
 					},
 					"__wbg_setStart_8e286af3a7fa93e1": function(p0i32,p1i32,p2i32) {
 						return installedModules[2].exports["kb"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_setStartAfter_f3921b9eb3c59bb7": function(p0i32,p1i32) {
 						return installedModules[2].exports["ib"](p0i32,p1i32);
 					},
 					"__wbg_setStartBefore_785537795e6fb48c": function(p0i32,p1i32) {
 						return installedModules[2].exports["jb"](p0i32,p1i32);
 					},
 					"__wbg_length_8a6a2efe955a8b70": function(p0i32) {
 						return installedModules[2].exports["R"](p0i32);
 					},
 					"__wbg_item_102e71580fef0207": function(p0i32,p1i32) {
 						return installedModules[2].exports["P"](p0i32,p1i32);
 					},
 					"__wbg_get_b98c84aa64400fbe": function(p0i32,p1i32) {
 						return installedModules[2].exports["B"](p0i32,p1i32);
 					},
 					"__wbg_instanceof_Text_cbaefa3d82bdddd8": function(p0i32) {
 						return installedModules[2].exports["N"](p0i32);
 					},
 					"__wbg_instanceof_Node_11254aed560b4c66": function(p0i32) {
 						return installedModules[2].exports["M"](p0i32);
 					},
 					"__wbg_nodeType_f5e54979099baba1": function(p0i32) {
 						return installedModules[2].exports["X"](p0i32);
 					},
 					"__wbg_nodeName_7babcf625aec4083": function(p0i32,p1i32) {
 						return installedModules[2].exports["W"](p0i32,p1i32);
 					},
 					"__wbg_childNodes_3ea42a8e103679b0": function(p0i32) {
 						return installedModules[2].exports["g"](p0i32);
 					},
 					"__wbg_lastChild_86e1c02df2b342d8": function(p0i32) {
 						return installedModules[2].exports["Q"](p0i32);
 					},
 					"__wbg_nodeValue_2b31b791bfa62a8d": function(p0i32,p1i32) {
 						return installedModules[2].exports["Y"](p0i32,p1i32);
 					},
 					"__wbg_appendChild_5a186a381c8fff5b": function(p0i32,p1i32) {
 						return installedModules[2].exports["e"](p0i32,p1i32);
 					},
 					"__wbg_contains_87699bbfe7e284cd": function(p0i32,p1i32) {
 						return installedModules[2].exports["m"](p0i32,p1i32);
 					},
 					"__wbg_hasChildNodes_92f3eb57464fc1ac": function(p0i32) {
 						return installedModules[2].exports["E"](p0i32);
 					},
 					"__wbg_insertBefore_83c912a1a16c68d2": function(p0i32,p1i32,p2i32) {
 						return installedModules[2].exports["H"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_normalize_b780513d171a31fd": function(p0i32) {
 						return installedModules[2].exports["Z"](p0i32);
 					},
 					"__wbg_removeChild_a5458e964695297f": function(p0i32,p1i32) {
 						return installedModules[2].exports["cb"](p0i32,p1i32);
 					},
 					"__wbg_instanceof_Element_b2ea0d558fc7d331": function(p0i32) {
 						return installedModules[2].exports["J"](p0i32);
 					},
 					"__wbg_tagName_c547ea7972faad1b": function(p0i32,p1i32) {
 						return installedModules[2].exports["ob"](p0i32,p1i32);
 					},
 					"__wbg_id_1d70bdde705a2f65": function(p0i32,p1i32) {
 						return installedModules[2].exports["F"](p0i32,p1i32);
 					},
 					"__wbg_classList_262889e9fed65a4e": function(p0i32) {
 						return installedModules[2].exports["h"](p0i32);
 					},
 					"__wbg_setAttribute_65dde98f32b42a41": function(p0i32,p1i32,p2i32,p3i32,p4i32) {
 						return installedModules[2].exports["eb"](p0i32,p1i32,p2i32,p3i32,p4i32);
 					},
 					"__wbg_debug_ad2e107500a5e66f": function(p0i32) {
 						return installedModules[2].exports["p"](p0i32);
 					},
 					"__wbg_error_899f34a74e6ae34f": function(p0i32) {
 						return installedModules[2].exports["v"](p0i32);
 					},
 					"__wbg_info_9f243b6555ae61bc": function(p0i32) {
 						return installedModules[2].exports["G"](p0i32);
 					},
 					"__wbg_log_8c015365353ccd49": function(p0i32) {
 						return installedModules[2].exports["T"](p0i32);
 					},
 					"__wbg_warn_22c4a606fdfb0a53": function(p0i32) {
 						return installedModules[2].exports["pb"](p0i32);
 					},
 					"__wbg_instanceof_HtmlElement_67a9589b0f1c5c31": function(p0i32) {
 						return installedModules[2].exports["L"](p0i32);
 					},
 					"__wbg_focus_2617465192028e1c": function(p0i32) {
 						return installedModules[2].exports["x"](p0i32);
 					},
 					"__wbg_data_e09ed4fd8944fe35": function(p0i32,p1i32) {
 						return installedModules[2].exports["o"](p0i32,p1i32);
 					},
 					"__wbg_length_cca45aa2d6b01dfc": function(p0i32) {
 						return installedModules[2].exports["S"](p0i32);
 					},
 					"__wbg_instanceof_HtmlDocument_4e420d706512e41e": function(p0i32) {
 						return installedModules[2].exports["K"](p0i32);
 					},
 					"__wbg_execCommand_81e83cf93eb6abe3": function(p0i32,p1i32,p2i32,p3i32,p4i32,p5i32) {
 						return installedModules[2].exports["w"](p0i32,p1i32,p2i32,p3i32,p4i32,p5i32);
 					},
 					"__wbg_add_0850d066114a0d43": function(p0i32,p1i32,p2i32,p3i32,p4i32) {
 						return installedModules[2].exports["c"](p0i32,p1i32,p2i32,p3i32,p4i32);
 					},
 					"__wbg_rangeCount_d9e8306d3ad9a1c4": function(p0i32) {
 						return installedModules[2].exports["ab"](p0i32);
 					},
 					"__wbg_addRange_fbef75e804365d45": function(p0i32,p1i32) {
 						return installedModules[2].exports["b"](p0i32,p1i32);
 					},
 					"__wbg_getRangeAt_778d713a86839a99": function(p0i32,p1i32) {
 						return installedModules[2].exports["z"](p0i32,p1i32);
 					},
 					"__wbg_removeAllRanges_54eda87c037227c5": function(p0i32) {
 						return installedModules[2].exports["bb"](p0i32);
 					},
 					"__wbg_newnoargs_db0587fa712f9acc": function(p0i32,p1i32) {
 						return installedModules[2].exports["V"](p0i32,p1i32);
 					},
 					"__wbg_call_79ca0d435495a83a": function(p0i32,p1i32) {
 						return installedModules[2].exports["f"](p0i32,p1i32);
 					},
 					"__wbg_self_d1b58dbab69d5bb1": function() {
 						return installedModules[2].exports["db"]();
 					},
 					"__wbg_window_de445cb18819ad4b": function() {
 						return installedModules[2].exports["qb"]();
 					},
 					"__wbg_globalThis_68afcb0d98f0112d": function() {
 						return installedModules[2].exports["C"]();
 					},
 					"__wbg_global_baed4e4fa850c0d0": function() {
 						return installedModules[2].exports["D"]();
 					},
 					"__wbindgen_is_undefined": function(p0i32) {
 						return installedModules[2].exports["sb"](p0i32);
 					},
 					"__wbindgen_debug_string": function(p0i32,p1i32) {
 						return installedModules[2].exports["rb"](p0i32,p1i32);
 					},
 					"__wbindgen_throw": function(p0i32,p1i32) {
 						return installedModules[2].exports["wb"](p0i32,p1i32);
 					}
 				}
 			};
 		},
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// Fetch + compile chunk loading for webassembly

 		var wasmModules = {"1":[57]}[chunkId] || [];

 		wasmModules.forEach(function(wasmModuleId) {
 			var installedWasmModuleData = installedWasmModules[wasmModuleId];

 			// a Promise means "currently loading" or "already loaded".
 			if(installedWasmModuleData)
 				promises.push(installedWasmModuleData);
 			else {
 				var importObject = wasmImportObjects[wasmModuleId]();
 				var req = fetch(__webpack_require__.p + "" + {"57":"ab6cbee57b036ac8e1b7"}[wasmModuleId] + ".module.wasm");
 				var promise;
 				if(importObject instanceof Promise && typeof WebAssembly.compileStreaming === 'function') {
 					promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
 						return WebAssembly.instantiate(items[0], items[1]);
 					});
 				} else if(typeof WebAssembly.instantiateStreaming === 'function') {
 					promise = WebAssembly.instantiateStreaming(req, importObject);
 				} else {
 					var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
 					promise = bytesPromise.then(function(bytes) {
 						return WebAssembly.instantiate(bytes, importObject);
 					});
 				}
 				promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
 					return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
 				}));
 			}
 		});
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// object with all WebAssembly.instance exports
 	__webpack_require__.w = {};

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
